<div class="row">
  <div class="col-12">

    <p>Please enter the email address you verified for your account. We will send you an email containing
      your username and a link to return to the login page.</p>

    <div id="usernameEmailSentAlert" class="alert alert-success mb-4 py-4" role="alert" *ngIf="usernameByEmailRequestSent"
         [@showUsernameEmailSentAlert]>
        <span>If the email address you entered is associated with an account and verified,
          we will send an email containing your username.</span>
    </div>

    <div id="genericErrorAlert" class="alert alert-danger mb-4 py-4" role="alert" *ngIf="genericErrorAlertShown"
         [@showGenericErrorAlert]>
      <p>We encountered an issue completing your request.</p>
      <span class="alert-span">Please try again later or contact Customer Service at {{ customerServicePhone }}.</span>
    </div>

    <form id="forgotUsernameForm" class="mb-2" [formGroup]="forgotUsernameForm" (ngSubmit)="sendUsernameViaEmail()">

      <div class="form-group form-label-group">
        <input id="emailInput" formControlName="emailInput" class="form-control"
               placeholder="Enter Verified Email"
               [ngClass]="{ 'is-invalid': sendUsernameViaEmailButtonClicked && forgotUsernameForm.controls.emailInput.errors }">
        <label for="emailInput">Enter Verified Email</label>
        <div *ngIf="sendUsernameViaEmailButtonClicked && forgotUsernameForm.controls.emailInput.errors" class="invalid-feedback">
          <div *ngIf="forgotUsernameForm.controls.emailInput.errors.required">Email Address is required.</div>
          <div *ngIf="forgotUsernameForm.controls.emailInput.errors.email">Email Address is invalid.</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 d-flex">
          <button type="submit" form="forgotUsernameForm"
                  class="btn rounded-pill bg-secondary ml-auto text-white px-4 py-2">
            <span class="font-weight-bold">Send Username Via Email</span>
          </button>
        </div>
      </div>
    </form>

    <div class="row mb-2" *ngIf="usernameByEmailRequestSent" [@showResendEmailButton]>
      <div class="col-12 d-flex">
        <span class="ml-auto">Haven’t received your email? <a href="" (click)="resendUsernameEmail(); false;">Resend Email</a></span>
      </div>
    </div>

    <div *ngIf="usernameByEmailResentButtonClicked" [@showUsernameEmailResentMessage]>
      <div class="row">
        <div class="col-12 d-flex">
          <small class="ml-auto"><strong>The email containing your username has been resent.</strong></small>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex">
          <small class="ml-auto">Still having trouble? Please contact us at {{ customerServicePhone }}.</small>
        </div>
      </div>
    </div>

  </div>
</div>
